import { render, staticRenderFns } from "./TableEmpresaSelecionadas.vue?vue&type=template&id=5ef60a54&scoped=true&"
import script from "./TableEmpresaSelecionadas.vue?vue&type=script&lang=js&"
export * from "./TableEmpresaSelecionadas.vue?vue&type=script&lang=js&"
import style0 from "./TableEmpresaSelecionadas.vue?vue&type=style&index=0&id=5ef60a54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef60a54",
  null
  
)

export default component.exports